// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleLevelInputTitle } from './moduleLevelInputTitle';
import type { ModuleLevelInputObjectives } from './moduleLevelInputObjectives';

/**
 * Level of a modul with its optional title
 */
export interface ModuleLevelInput {
  id: number;
  title?: ModuleLevelInputTitle;
  objectives?: ModuleLevelInputObjectives;
}
